import { Card } from '@maas-components/core'
import Tooltip from '@material-ui/core/Tooltip'
import styled from 'styled-components'

export const StyledCard = styled(Card)`
  border: 1px solid #ececec;
  padding: 24px 16px 24px 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #f7f7f7;
  min-width: 285px;
`

export const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip classes={{ popper: className, tooltip: 'tooltip' }} {...props} />
))`
  & .tooltip {
    background-color: ${({ theme }) => theme.palette.secondary.contrastText};
    color: ${({ theme }) => theme.palette.secondary.dark};
    box-shadow: ${({ theme }) => theme.shadows[5]};
    padding: 16px;
    min-width: 320px;
  }
  & [class*='MuiTooltip-arrow'] {
    color: ${({ theme }) => theme.palette.secondary.contrastText};

    ::before {
      border: 1px solid rgb(206 207 209 / 50%);
    }
  }
`
